import { Spinner } from '@change/ds-core-ui';

import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import { withPrefetchedData } from '#src/shared/prefetch';

import type { TemplatePrefetchedDataProps } from '#src/app/pages/landing/template/pageContext';
import { prefetchPageContext, TemplatePageContextProvider } from '#src/app/pages/landing/template/pageContext';

import CONTENT_PLACEHOLDERS from '../landing-content.i18n.yml';
import { Layout } from '../layout';

import { TemplateErrorHandler } from './ErrorHandler';

const TemplatePage = withPrefetchedData(
	function TemplatePage({ prefetchedData }: TemplatePrefetchedDataProps) {
		return (
			<TemplatePageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={TemplateErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</TemplatePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);

export const Template = withI18nPlaceholders(CONTENT_PLACEHOLDERS, TemplatePage);
